import { FRIENDLY_DETAIL_PATTERN, TOOL_DETAIL_PATTERN } from './progressLabelData.js'

export function friendlyProgressTraceText(event) {
  if (!event || typeof event !== 'object') return ''
  return `${event.friendlyLabel || 'Working'} · ${friendlyProgressStatus(event.status)}`
}

export function friendlyProgressDetailText(value, labelForText) {
  const text = cleanString(value)
  if (!text) return ''
  if (isFriendlyDetailText(text)) return text
  return `${labelForText(text)} · ${friendlyProgressStatus(statusFromText(text))}`
}

export function friendlyProgressStatus(status) {
  const value = normalized(status)
  if (['completed', 'complete', 'succeeded', 'success'].includes(value)) return 'done'
  if (['failed', 'error'].includes(value)) return 'needs attention'
  return 'working'
}

export function friendlyToolProgressLabel(count) {
  return `Used ${count} ${count === 1 ? 'tool' : 'tools'}`
}

export function isToolProgressEvent(event) {
  if (!event || typeof event !== 'object') return false
  const kind = normalized(event.eventKind)
  const type = normalized(event.type)
  return kind === 'tool_call' || type === 'tool_call' || Boolean(cleanString(event.toolName))
}

export function cleanString(value) {
  return typeof value === 'string' ? value.trim() : ''
}

export function normalized(value) {
  return cleanString(value).toLowerCase().replaceAll('-', '_')
}

function isFriendlyDetailText(text) {
  return TOOL_DETAIL_PATTERN.test(text) || FRIENDLY_DETAIL_PATTERN.test(text)
}

function statusFromText(text) {
  if (/\b(completed|complete|succeeded|success|done)\b/i.test(text)) return 'completed'
  if (/\b(failed|error)\b/i.test(text)) return 'failed'
  return ''
}
